module.exports = __webpack_public_path__ + "static/media/diagnosis_2_icon.899c78b8.png";